import { isFeatureUnlocked } from "@/common/featureLock.js";

export const GRIDS_DATA_TYPE_GDELT_ALL = "allgdeltv2";

export const GRIDS_TYPES_STABILITY = "stability";
export const GRIDS_TYPES_ACTIVITY = "activity";
export const GRIDS_TYPES = {
  stability: GRIDS_TYPES_STABILITY,
  activity: GRIDS_TYPES_ACTIVITY,
};
export const GRIDS_STABILITY_TYPES_WATER = "water";
export const GRIDS_STABILITY_TYPES_PORT = "port";
export const GRIDS_STABILITY_TYPES_COUNTRY = "country";
export const GRIDS_STABILITY_TYPES_REGION = "region";
export const GRIDS_STABILITY_TYPES_CITY = "city";
export const GRIDS_STABILITY_TYPES_COUNTY = "county";
export const GRIDS_STABILITY_TYPES = {
  country: GRIDS_STABILITY_TYPES_COUNTRY,
  region: GRIDS_STABILITY_TYPES_REGION,
  city: GRIDS_STABILITY_TYPES_CITY,
  county: GRIDS_STABILITY_TYPES_COUNTY,
  water: GRIDS_STABILITY_TYPES_WATER,
  port: GRIDS_STABILITY_TYPES_PORT,
};

export const GRIDS_STABILITY_LEVELS = [
  { id: 1, level: "level1" },
  { id: 2, level: "level2" },
  { id: 3, level: "level3" },
  { id: 4, level: "level4" },
  { id: 5, level: "level5" },
];

export const GRIDS_HOTSPOTS_LEVELS = [
  { id: 1, level: "level1" },
  { id: 2, level: "level2" },
  { id: 3, level: "level3" },
];

export const GRIDS_SCORE_RANGE_DEFAULTS_ACTIVITY = [
  {
    id: 1,
    min: null,
    max: 2.5,
    level: "Very Low",
    minLevel: null,
    maxLevel: "very_low",
    color: "Purple",
    title: "Less than max%",
    selected: true,
  },
  {
    id: 2,
    min: 2.5,
    max: 16,
    level: "Low",
    minLevel: "very_low",
    maxLevel: "low",
    color: "Blue",
    title: "Greater than or equal to min% and less than or equal to max%",
    selected: true,
  },
  {
    id: 3,
    min: 16,
    max: 64,
    level: "Expected",
    minLevel: "low",
    maxLevel: "high",
    color: "Green",
    title: "Greater than min% and less than max%",
    selected: false,
  },
  {
    id: 4,
    min: 64,
    max: 97.5,
    level: "High",
    minLevel: "high",
    maxLevel: "very_high",
    color: "Yellow",
    title: "Greater than or equal to min% and less than or equal to max%",
    selected: true,
  },
  {
    id: 5,
    min: 97.5,
    max: null,
    level: "Very High",
    minLevel: "very_high",
    maxLevel: null,
    color: "Red",
    title: "Greater than min%",
    selected: true,
  },
];

export let GRIDS_STABILITY_COLORS_VERY_HIGH = "#4DC400";
export let GRIDS_STABILITY_COLORS_HIGH = "#ADD600";
export let GRIDS_STABILITY_COLORS_NEUTRAL = "#FFC600";
export let GRIDS_STABILITY_COLORS_LOW = "#FF6700";
export let GRIDS_STABILITY_COLORS_VERY_LOW = "#C10000";

export let GRIDS_STABILITY_COLORS = {
  veryhigh: GRIDS_STABILITY_COLORS_VERY_HIGH,
  high: GRIDS_STABILITY_COLORS_HIGH,
  neutral: GRIDS_STABILITY_COLORS_NEUTRAL,
  low: GRIDS_STABILITY_COLORS_LOW,
  verylow: GRIDS_STABILITY_COLORS_VERY_LOW,
};

export const GRIDS_STABILITY_RANGES_VERY_HIGH = { min: 71, max: 100 };
export const GRIDS_STABILITY_RANGES_HIGH = { min: 56, max: 70 };
export const GRIDS_STABILITY_RANGES_NEUTRAL = { min: 46, max: 55 };
export const GRIDS_STABILITY_RANGES_LOW = { min: 31, max: 45 };
export const GRIDS_STABILITY_RANGES_VERY_LOW = { min: 0, max: 30 };

// NOTE: the min/max values below are supposed to set to the .max of
// the ranges so that they overlap. The mapboxgl step function within the
// style ends up just using the min value to display
// e.g. [“step”, [“get”, “co”], “#D15B54", 30, “#F1BF8B”, 45, “#FEFFD1", 55, “#C1DF93”, 70, “#6CA96F”]
export let GRIDS_SCORE_RANGE_DEFAULTS_STABILITY = (GRIDS_SCORE_RANGE_DEFAULTS_STABILITY = [
  {
    id: 1,
    min: null,
    max: GRIDS_STABILITY_RANGES_VERY_LOW.max,
    level: "Very Unstable",
    minLevel: null,
    maxLevel: "very_low",
    color: GRIDS_STABILITY_COLORS.verylow,
    title: "Less than max%",
    selected: true,
  },
  {
    id: 2,
    min: GRIDS_STABILITY_RANGES_VERY_LOW.max,
    max: GRIDS_STABILITY_RANGES_LOW.max,
    level: "Unstable",
    minLevel: "very_low",
    maxLevel: "low",
    color: GRIDS_STABILITY_COLORS.low,
    title: "Greater than or equal to min% and less than or equal to max%",
    selected: true,
  },
  {
    id: 3,
    min: GRIDS_STABILITY_RANGES_LOW.max,
    max: GRIDS_STABILITY_RANGES_NEUTRAL.max,
    level: "Volatile",
    minLevel: "low",
    maxLevel: "high",
    color: GRIDS_STABILITY_COLORS.neutral,
    title: "Greater than or equal to min% and less than or equal to max%",
    selected: true,
  },
  {
    id: 4,
    min: GRIDS_STABILITY_RANGES_NEUTRAL.max,
    max: GRIDS_STABILITY_RANGES_HIGH.max,
    level: "Stable",
    minLevel: "high",
    maxLevel: "very_high",
    color: GRIDS_STABILITY_COLORS.high,
    title: "Greater than or equal to min% and less than or equal to max%",
    selected: false,
  },
  {
    id: 5,
    min: GRIDS_STABILITY_RANGES_HIGH.max,
    max: GRIDS_STABILITY_RANGES_VERY_HIGH.max,
    level: "Very Stable",
    minLevel: "very_high",
    maxLevel: null,
    color: GRIDS_STABILITY_COLORS.veryhigh,
    title: "Greater than min%",
    selected: true,
  },
]);
export const GRIDS_SCORE_RANGE_DEFAULTS = {
  stability: GRIDS_SCORE_RANGE_DEFAULTS_STABILITY,
  activity: GRIDS_SCORE_RANGE_DEFAULTS_ACTIVITY,
};

export const GRIDS_INFLUENCE_DRIVERS = {
  social: "social",
  political: "political",
  economic: "economic",
};
